// extracted by mini-css-extract-plugin
module.exports =  {"choices":"choices-Whebd","choice":"choice-jFjGc","choice-copy":"choice-copy-yOU1h","description":"description-K0HUB","empty":"empty-I1k3y"};